var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('hi-base',{attrs:{"span":_vm.span}},[_c('FormItem',{staticStyle:{"width":"100%"},attrs:{"label":_vm.L(this.labelKey),"label-width":_vm.labelWidth}},[_c('Checkbox',{attrs:{"value":_vm.value,"disabled":_vm.disabled},on:{"on-change":value => _vm.$emit('input', value)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }